module.exports = __webpack_public_path__ + "media/roll-wheel.ab5a5659.wav";